<script lang="ts">
  // Indeterminate loading indicator. Sized to match Button heights so it
  // can sit inline inside a `loading` button without shifting layout.
  // CSS animation only — no JS needed; respects prefers-reduced-motion
  // by slowing rather than freezing (a stationary spinner reads as broken).

  interface Props {
    size?: 'sm' | 'md' | 'lg';
    /** Optional accessible label. Defaults to "Loading". */
    label?: string;
  }

  let { size = 'md', label = 'Loading' }: Props = $props();
</script>

<span
  class="ui-spinner"
  class:ui-spinner--sm={size === 'sm'}
  class:ui-spinner--md={size === 'md'}
  class:ui-spinner--lg={size === 'lg'}
  role="status"
  aria-label={label}
>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
  </svg>
</span>
